import { render, staticRenderFns } from "./TicketDetails.vue?vue&type=template&id=7d3d67e6&"
import script from "./TicketDetails.vue?vue&type=script&lang=ts&"
export * from "./TicketDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports